import { LayoutHOC } from "base/ui/layout/layout";
import createCatalogType from "./CatalogType";

export const createCatalogTypePage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createCatalogType());
};
